import Network from '../../lib/api/network';

let originalDocumentTitle;

let warningTimeoutId = null;
let expiredTimeoutId = null;

function clearScheduledTimers() {
  if (warningTimeoutId) {
    clearTimeout(warningTimeoutId);
    warningTimeoutId = null;
  }
  if (expiredTimeoutId) {
    clearTimeout(expiredTimeoutId);
    expiredTimeoutId = null;
  }
}

export default {
  updateSessionTimeout({ commit, dispatch }, { expiresAt, warnAt }) {
    commit('update', { key: 'sessionTimeout', value: { expiresAt, warnAt } });
    dispatch('scheduleSessionTimeoutCheck');
  },

  // (Re-)sets the warning/expiry timers off the current state.sessionTimeout.expiresAt/warnAt.
  // Called once at bootstrap, and again after every real request's response headers refresh
  // those values, so the timers always reflect the latest known expiry rather than the one
  // computed at initial page load.
  scheduleSessionTimeoutCheck({ state, commit, dispatch }) {
    clearScheduledTimers();

    const { expiresAt, warnAt } = state.sessionTimeout || {};
    if (!expiresAt || !warnAt) return;

    const now = Date.now();

    const openWarning = () => {
      if (state.modal.subcomponent !== 'donut-modal-session-timeout') {
        originalDocumentTitle = document.title;
        commit('updateModal', {
          visible: true,
          dismissable: false,
          subcomponent: 'donut-modal-session-timeout',
          data: { phase: 'warning' },
          cancelMutation: 'updateModal',
          cancelArgs: state.modal,
        });
        document.title = 'Session expiring soon — still there?';
      }
    };

    const openExpired = () => {
      // Deliberately updates the *same* open modal in place (per design: don't auto-redirect,
      // don't close and reopen) rather than replacing it outright.
      commit('updateExistingModal', { data: { phase: 'expired' } });
      document.title = 'Session expired';
    };

    const closeWarningIfStale = () => {
      if (
        state.modal.subcomponent !== 'donut-modal-session-timeout'
        || state.modal.data?.phase !== 'warning'
      ) {
        return;
      }

      dispatch('cancelModal');
      document.title = originalDocumentTitle;
    };

    if (now >= expiresAt) {
      openWarning();
      openExpired();
      return;
    }

    if (now >= warnAt) {
      openWarning();
    } else {
      closeWarningIfStale();
      warningTimeoutId = setTimeout(openWarning, warnAt - now);
    }

    expiredTimeoutId = setTimeout(openExpired, expiresAt - now);
  },

  // A deliberate, user-initiated keepalive
  // The server's response carries the refreshed expiresAt/warnAt via response headers
  keepSessionAlive({ commit }) {
    const markExpired = () => {
      clearScheduledTimers();
      commit('updateExistingModal', { data: { phase: 'expired' } });
      document.title = 'Session expired';
    };

    return new Promise((resolve) => {
      Network.get('/session_keep_alive', {
        success: () => resolve(true),
        error: (jqXHR) => {
          if (jqXHR?.status === 401) markExpired();
          resolve(false);
        },
      });
    });
  },
};
